"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var downshift_1 = __importDefault(require("downshift"));

var react_1 = __importStar(require("react"));

var theme_1 = require("../../../styles/theme");

var Chevron_1 = __importDefault(require("../../../icons/Chevron"));

var Container = styled_1["default"]('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var ToggleContainer = styled_1["default"]('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  text-align: left;\n  font-size: 1em;\n  white-space: nowrap;\n"], ["\n  display: inline-block;\n  text-align: left;\n  font-size: 1em;\n  white-space: nowrap;\n"])));
var ToggleButton = styled_1["default"]('button')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  border: none;\n  font: inherit;\n  color: ", ";\n  background-color: transparent;\n  cursor: pointer;\n  padding-left: 0;\n"], ["\n  display: inline-block;\n  border: none;\n  font: inherit;\n  color: ", ";\n  background-color: transparent;\n  cursor: pointer;\n  padding-left: 0;\n"])), theme_1.theme.colors.Clay100);
var ToggleArrow = styled_1["default"](Chevron_1["default"])(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  float: right;\n  margin-right: -0.8em;\n  background-color: transparent;\n  ", " {\n    margin-right: 0;\n    margin-top: 0.2em;\n  }\n"], ["\n  float: right;\n  margin-right: -0.8em;\n  background-color: transparent;\n  ", " {\n    margin-right: 0;\n    margin-top: 0.2em;\n  }\n"])), theme_1.theme.breakpoints.desktopDown);
var Menu = styled_1["default"]('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: block;\n  position: absolute;\n  background-color: #fff;\n  box-shadow: 3px 3px 5px 0px rgba(216, 217, 230, 1);\n  z-index: 1;\n  padding: 1em;\n  border-width: 0 1px 1px 1px;\n  border-color: ", ";\n  border-radius: 3px;\n  ", " {\n    position: relative;\n    border: none;\n    box-shadow: none;\n  }\n"], ["\n  display: block;\n  position: absolute;\n  background-color: #fff;\n  box-shadow: 3px 3px 5px 0px rgba(216, 217, 230, 1);\n  z-index: 1;\n  padding: 1em;\n  border-width: 0 1px 1px 1px;\n  border-color: ", ";\n  border-radius: 3px;\n  ", " {\n    position: relative;\n    border: none;\n    box-shadow: none;\n  }\n"])), theme_1.theme.colors.Clay12, theme_1.theme.breakpoints.desktopDown);

var ToggleMenu =
/** @class */
function (_super) {
  __extends(ToggleMenu, _super);

  function ToggleMenu(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {// selectedOption: undefined
    };
    _this.buttonRef = react_1["default"].createRef();
    _this.menuRef = react_1["default"].createRef();
    _this.toggleRef = react_1["default"].createRef();
    return _this;
  }
  /* tslint:disable */


  ToggleMenu.prototype.render = function () {
    var _this = this;

    var text = this.props.text; // NOTE: this uses some inline styles since Downshift requires
    // additional configuration to support non-native elements
    // (i.e. divs vs. styled components)
    // Also note: refs use `as any` to fix a TypeScript problem referenced in
    //  https://github.com/DefinitelyTyped/DefinitelyTyped/issues/28884#issuecomment-435485972

    return react_1["default"].createElement(Container, null, react_1["default"].createElement(downshift_1["default"], {
      onStateChange: this.onStateChange,
      itemToString: function itemToString(item) {
        return item ? [item.name, item.value].join('_') : '';
      }
    }, function (_a) {
      var isOpen = _a.isOpen,
          getMenuProps = _a.getMenuProps,
          getToggleButtonProps = _a.getToggleButtonProps;
      return react_1["default"].createElement("div", null, react_1["default"].createElement("div", {
        style: {
          cursor: 'pointer',
          display: 'inline-block'
        },
        ref: _this.toggleRef
      }, react_1["default"].createElement(ToggleContainer, __assign({}, getToggleButtonProps(), {
        isOpen: isOpen
      }), react_1["default"].createElement(ToggleArrow, {
        fill: theme_1.theme.colors.Clay80,
        rotation: isOpen ? 270 : 90
      }), react_1["default"].createElement(ToggleButton, {
        ref: _this.buttonRef
      }, text))), react_1["default"].createElement("div", {
        ref: _this.menuRef,
        style: {
          clear: 'both',
          position: 'relative'
        }
      }, !isOpen ? null : react_1["default"].createElement(Menu, __assign({}, getMenuProps(), {
        isOpen: isOpen
      }), _this.props.children)));
    }));
  };

  return ToggleMenu;
}(react_1.Component);

exports["default"] = ToggleMenu;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;